import classnames from 'classnames';
import { StepByStepProvider } from 'yoso';
import { useLand } from '~/components/Land/Land.hooks';
import { ParticipationFeeStep } from '~/components/Land/Participation/Fee/ParticipationFeeStep';
import { ParticipationSnapshotStep } from '~/components/Land/Participation/Snapshot/ParticipationSnapshotStep';
import { ParticipationSuccessStep } from '~/components/Land/Participation/Success/ParticipationSuccessStep';
import { BottomSheet, BottomSheetProps } from '~/components/Modal/BottomSheet/BottomSheet';
import landStyles from '~/components/Style/Land.module.scss';
import styles from './ParticipationBottomSheet.module.scss';

export const steps = ['FEE', 'SNAPSHOT', 'SUCCESS'];

export type ParticipationBottomSheetProps = {
  landId: number;
  zoneId: number;
} & BottomSheetProps;

export const ParticipationBottomSheet = ({
  landId,
  zoneId,
  className,
  onConfirm,
  onDismiss,
  ...props
}: ParticipationBottomSheetProps) => {
  const {
    data: { landType },
  } = useLand(landId);
  return (
    <StepByStepProvider steps={steps}>
      <BottomSheet
        className={classnames(styles.root, landStyles[landType], className)}
        onConfirm={onConfirm}
        onDismiss={onDismiss}
        {...props}
        size="full">
        <ParticipationFeeStep className={styles.step} landId={landId} zoneId={zoneId} />
        <ParticipationSnapshotStep
          className={styles.step}
          landId={landId}
          zoneId={zoneId}
          onDismiss={onDismiss}
        />
        <ParticipationSuccessStep
          className={styles.step}
          landId={landId}
          zoneId={zoneId}
          onConfirm={onConfirm}
        />
      </BottomSheet>
    </StepByStepProvider>
  );
};
